// MACHINERY V2 (Stroje) — Diely a materiál: the PHONE card (artboard 1013;
// board 24 of the mobile package). Split out of partsRows.tsx at M2.16d step 3,
// near-cap rule.
//
// WHY IT IS SEPARATE: partsRows.tsx stood at 252 of the 300-line cap and this
// sub-phase adds a touch target to the select control. The seam is the module's
// own breakpoint: partsRows.tsx now renders ONLY the >= 768 grid row, this file
// renders ONLY the < 768 card, and both read one contract
// (partsRowContract.ts) so a column, a prop or the number reader cannot drift
// between them.
//
// BOARD 24, AND WHAT IT DOES NOT DRAW. The board shows thumb + mono number +
// "brand · category" + "8 ks / 24 ks" + kebab, which is exactly what shipped at
// M2.5 — it is NOT rebuilt here. The board draws NO select checkbox; the
// checkbox is kept anyway, because dropping it would delete the only way to
// reach bulk unlink on a phone and the board simply did not consider the bulk
// bar. It is given a legal touch target instead (the `touch` prop), which is
// the difference this file exists to make.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

import FleetCardMenu from "../../fleet/FleetCardMenu";
import { InstalledOverStock, PartCheckbox, PartThumb } from "./partsAtoms";
import { PartRowProps, partNumber } from "./partsRowContract";

/** Phone card (artboard 1013 / board 24). */
const PartPhoneCard: React.FC<PartRowProps> = ({
  item,
  selected,
  onToggleSelect,
  actions,
  menuLabel,
  selectLabel,
  touch,
}) => {
  const stock = item.stockItem;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: 10,
        borderRadius: 10,
        background: selected ? "var(--mod-accent-soft)" : "var(--card)",
        border: "1px solid " + (selected ? "var(--mod-accent-line)" : "var(--border)"),
        width: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        minWidth: 0,
      }}
    >
      <PartCheckbox checked={selected} label={selectLabel} onChange={onToggleSelect} touch={touch} />
      <PartThumb src={stock?.file?.content} size={38} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 12,
            fontWeight: 700,
            color: "var(--ink)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {partNumber(item)}
        </div>
        <div
          style={{
            fontSize: 11,
            color: "var(--muted)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {[stock?.product?.manufacturer?.name, stock?.product?.category?.name]
            .filter(Boolean)
            .join(" · ")}
        </div>
        <div style={{ marginTop: 2 }}>
          <InstalledOverStock installed={item.quantity} inStock={item.inStockQuantity} />
        </div>
      </div>
      <FleetCardMenu actions={actions} ariaLabel={menuLabel} />
    </div>
  );
};

export default PartPhoneCard;
